import {ZIDX, ZIDXPage} from "../../../../standalone/standaloneLibrary.js";

export class ZIDXAccountRetsServerEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountRetsServerEditContainer";
    }
    render(){
        // console.log("data feeds");
    }
}